module.exports = __webpack_public_path__ + "img/pink-ocean.4b949e21.jpeg";